import PastClassModal from "./PastClassModal";

export default PastClassModal;
